<template>
  <a-card title="RAM & SWAP" class="inner--card">
    <span slot="extra">
      <a-button :type="activeButton === 'yearly' ? 'primary' : 'default'"
          class="mr--4"
          @click="regenerateGraph('yearly')"
      >Yearly</a-button>
      <a-button
          :type="activeButton === 'monthly' ? 'primary' : 'default'"
          class="mr--4"
          @click="regenerateGraph('monthly')"
      >Monthly</a-button>
      <a-button
          :type="activeButton === 'daily' ? 'primary' : 'default'"
          class="mr--4"
          @click="regenerateGraph('daily')"
      >Daily</a-button>
      <a-button
          class="mr--18"
          :type="activeButton === 'hourly' ? 'primary' : 'default'"
          @click="regenerateGraph('hourly')"
      >Hourly</a-button>
      <a-button
          @click="reload()"
          shape="circle"
          :loading="loading"
      ><a-icon type="reload" v-if="!loading" /></a-button>
    </span>
    <canvas width="100%" height="330" ref="ramSwapGraph"></canvas>
  </a-card>
</template>

<script>
import Chart from "chart.js";
import { mapGetters } from 'vuex';

export default {
  props: ['server'],
  data() {
    return {
      activeButton: 'hourly',
      loading: false
    };
  },
  computed: {
    ...mapGetters({
      ramSwapUsage: 'servers/getRamSwapUsage'
    })
  },
  methods: {
    reRenderChart() {
      let chartData = {
        labels: this.ramSwapUsage.labels,
        datasets: [
          {
            label: "RAM: ",
            fill: false,
            borderColor: "#61CF35",
            borderWidth: 3,
            data: this.ramSwapUsage.ram
          },
          {
            label: "SWAP: ",
            fill: false,
            borderColor: "#42ADEB",
            borderWidth: 3,
            data: this.ramSwapUsage.swap
          }
        ]
      };

      new Chart(this.$refs.ramSwapGraph.getContext("2d"), {
        type: "line",
        data: chartData,
        options: {
          maintainAspectRatio: false,
          responsive: true,
          title: {
            display: false
          },
          legend: {
            display: false
          },
          scales: {
            xAxes: [
              {
                gridLines: {
                  display: false,
                  drawBorder: true,
                  drawTicks: true
                }
              }
            ],
            yAxes: [
              {
                gridLines: {
                  display: true,
                  drawBorder: false,
                  drawTicks: true
                },
                ticks: {
                  min: 0
                }
              }
            ]
          },
          tooltips: {
              enabled: true,
              mode: 'single',
              callbacks: {
                label: function(tooltipItems, data) {
                  return data.datasets[tooltipItems.datasetIndex].label +': ' + tooltipItems.yLabel + ' MB';
                }
              }
          }
        }
      });
    },
    renderGraph() {
      this.$store.dispatch('servers/RAM_SWAP_GRAPH_DATA_FROM_API', {serverId: this.server.db_server_id, type: 'hourly'}).then(() => {
        this.reRenderChart();
      });
    },
    regenerateGraph(type) {
      this.activeButton = type;
      this.$store.dispatch('servers/RAM_SWAP_GRAPH_DATA_FROM_API', {serverId: this.server.db_server_id, type: type}).then(() => {
        this.reRenderChart();
      });
    },
    reload() {
      this.loading = true;
      this.$store.dispatch('servers/RAM_SWAP_GRAPH_DATA_FROM_API', {serverId: this.server.db_server_id, type: this.activeButton}).then(() => {
        this.reRenderChart();
        this.loading = false;
      });
    }
  },
  mounted() {
    this.renderGraph();
  },
  watch: {
    values() {
      this.reRenderChart();
    }
  }
};
</script>
<style scoped>
  .inner--card { border: none; }
  .mr--4 { margin-right: 4px; }
  .mr--18 { margin-right: 18px; }
</style>